import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component that resets the window scroll position to (0, 0)
 * whenever the route path changes.
 */
export default function ScrollToTop() {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";

            return () => {
                window.history.scrollRestoration = "auto";
            };
        }
    }, []);

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, search, hash]);

    return null;
}
